import { toastr } from "react-redux-toastr";
import QueryString from 'query-string'
import { CLEAR_ITEM_CONDITIONS, FLAG_GETTING_ITEM_CONDITIONS, GET_ITEM_CONDITIONS } from "../types"
import { DEFAULT_GET_CONFIG } from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';
import { ITEM_CONDITION_ENDPOINT } from "../../config/endpoints";

const flagGettingItemConditions = (flag, key = 'regular') => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_ITEM_CONDITIONS,
    payload: { flag, key },
  });

const getItemConditions = async (tableFilters, key = 'regular') => async (dispatch) => {
  try {
    dispatch(flagGettingItemConditions(true, key));
    const url = `${ITEM_CONDITION_ENDPOINT}?${QueryString.stringify(tableFilters)}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const itemConditions = await response.json();
    dispatch({ type: GET_ITEM_CONDITIONS, payload: { data: itemConditions, key } });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagGettingItemConditions(false, key));
  }
}

const clearItemConditions = (key = 'regular') => (dispatch) =>
  dispatch({
    type: CLEAR_ITEM_CONDITIONS,
    payload: { key },
  });

export { getItemConditions, clearItemConditions };
